window.selectPickerOptions = 
{
    container: 'body',
    dropupAuto: false,
};
